/** ***********************************************************************
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ************************************************************************* */

import React, { Component } from 'react';
import Button from '@react/react-spectrum/Button';
import { CatalogAnalytics } from '../../../../analytics';
import { ANALYTICS } from '../../../../utils/enums';

export default class ConnectionFail extends Component {
    componentDidMount() {
        const { appConfig, appSection, failState } = this.props;
        CatalogAnalytics.sendAnalytics(appConfig,
            undefined,
            ANALYTICS.EVENTS.RENDER_CONNECTION_FAILED_PAGE,
            { appSection, eventValue: failState.pageType });
    }

    render() {
        const { appConfig, appSection, failState } = this.props;
        return (
            <div className="apps-section-content connection-fail-section">
                <div className="error-icon">
                    <img src={failState.getImageUrl()} alt="" />
                </div>
                <div className="error-heading">{failState.heading}</div>
                <div className="error-desc">{failState.description}</div>
                <Button
                    className="error-CTA"
                    variant="primary"
                    label={failState.CTALabel}
                    onClick={() => {
                        failState.onCTAClick();
                        CatalogAnalytics.sendAnalytics(appConfig,
                            undefined,
                            ANALYTICS.EVENTS.NO_CONNECTION_BTN_CLICK,
                            {
                                appSection,
                                subType: failState.ctaActionId,
                                eventValue: failState.pageType,
                                app: failState.app,
                            });
                    }} />
            </div>
        );
    }
}
